import { render, staticRenderFns } from "./DialogTip.vue?vue&type=template&id=661ef4d4&scoped=true"
import script from "./DialogTip.vue?vue&type=script&lang=js"
export * from "./DialogTip.vue?vue&type=script&lang=js"
import style0 from "./DialogTip.vue?vue&type=style&index=0&id=661ef4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661ef4d4",
  null
  
)

export default component.exports